import React from 'react'
import _ from 'lodash'

import PayAsYouGoCredits from './addons/pay_as_you_go_credits'
import PlanCard from './plans/plan_card'
import EnterpriseCard from './plans/enterprise_card'

import * as PricingConstants from './helpers/constant'

const CreditProducts = ({
  selectedToggle,
  payAsYouGoAddon,
  products,
  currency
}) => {

  if (_.isEmpty(products)) {
    return null
  }

  if (selectedToggle === 'payg' && !_.isEmpty(payAsYouGoAddon)) {
    return (
      <PayAsYouGoCredits
        showPayButton={false}
        addons={payAsYouGoAddon}
        currency={PricingConstants.CURRENCY.USD.name}
        isPublic={true}
      />
    )
  }


  const plansToDisplay = products[selectedToggle]

  if (_.isEmpty(plansToDisplay)) {
    return null
  }

  const freemiumPlans = plansToDisplay.freemium
  const starterPlans = plansToDisplay.starter
  const proPlans = plansToDisplay.pro
  const customPlans = plansToDisplay.custom
  let customCard = <EnterpriseCard />

  if (!_.isEmpty(customPlans)) {
    customCard = <PlanCard
      plans={customPlans}
      currency={currency}
      selectedToggle={selectedToggle}
    />
  }


  return (
    <div className='subscription-card-container'>
      {
        [freemiumPlans, starterPlans, proPlans].map((groupedPlans, index) => {
          if (!_.isEmpty(groupedPlans)) {
            return (
              <PlanCard
                key={index}
                plans={groupedPlans}
                currency={currency}
                selectedToggle={selectedToggle}
              />
            )
          }

          return null
        })
      }
      {customCard}
    </div>
  )
}

export default CreditProducts